module.exports = __webpack_public_path__ + "img/parallel-gateway.739418c1.svg";